<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card" style="width:400px;margin: 50px auto">
          <div slot="header" class="clearfix">
            <span>小蜜蜂报价器</span>
            <el-link type="primary" style="margin-left: 10px;float: right" icon="el-icon-question" @click="goXmfDoc">帮助文档
            </el-link>
          </div>
          <el-form ref="form" label-width="80px" >
            <el-form-item label="账号">
              <el-input placeholder="请输入账号" v-model="accountNo" maxlength="20" clearable></el-input>
            </el-form-item>
            <el-form-item label="密码">
              <el-input placeholder="请输入密码" v-model="password" maxlength="20" show-password></el-input>
            </el-form-item>
            <el-form-item>
              <el-checkbox v-model="keepPsd" @change="keepPsdChange">记住密码</el-checkbox>
              <el-button style="margin-left: 10px" type="primary" @click="login">登录</el-button>
              <el-button @click="register">注册</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
  import { initData } from '../api/MsgApi'
  import localforage from 'localforage'

  export default {
    name: 'Login',
    data () {
      return {
        accountNo: '',
        password: '',
        keepPsd:false,
        ip:''
      }
    },
    created () {
    },
    mounted () {
      this.isBrowser()
      this.ip=sessionStorage.getItem('ip')
      localforage.getItem('keepPsd').then(val=>{
        this.keepPsd=val
       if(val==true){
         localforage.getItem('user').then(val=>{
           if(val!=null){
             this.accountNo=val.accountNo
             this.password=val.password
           }
         })
       }
      })
    },
    methods: {
      login () {
        let that = this
        this.$http.post('/api/user/login', {
          accountNo: this.accountNo,
          ip:this.ip,
          password: this.password
        }).then(res => {
          if (res != null) {
            localStorage.setItem('token', res.data.token)
            let user = {
              accountNo: that.accountNo,
              name: res.data.nickName,
              companyName:res.data.companyName,
              img: 'https://xmf-pigeon.oss-cn-hangzhou.aliyuncs.com/public/%E5%AE%A2%E6%9C%8D%E5%A4%B4%E5%83%8F.jpg'
            }
            sessionStorage.setItem('user', JSON.stringify(user))
            sessionStorage.setItem('activeIndex', '1-1')
            //menu
            let menu = localStorage.getItem('menu_' + that.accountNo)
            let version = this.$store.state.menuVersion
            let defaultPriceUrls = []
            if (menu == null) {
              menu = that.$store.getters['defaultMenu']
            } else {
              let oldVersion = localStorage.getItem('menuVersion_' + that.accountNo)
              //版本号==null 则取默认值.
              if (version != oldVersion) {
                console.log('版本号不同')
                let newMenu = that.$store.getters['defaultMenu']
                menu = JSON.parse(menu)
                //版本号不同.对比数据.
                that._.forEach(newMenu, (value, key) => {
                  console.log(value)
                  //添加
                  if (that._.findLastIndex(menu, { id: value.id }) == -1) {
                    menu.push(value)
                  }
                  //修改
                  that._.forEach(menu, (oldVal, oldKey) => {
                    if (value.id == oldVal.id) {
                      if (value.path != oldVal.path) {
                        oldVal.path = value.path
                        menu[oldKey] = oldVal
                      }
                    }
                  })
                })
              } else {
                menu = JSON.parse(menu)
              }
            }

            defaultPriceUrls = menu.filter(x => {
              if (x.isCheck) {
                return x
              }
            })
            //去重
            menu = that._.uniqWith(menu, that._.isEqual)
            menu = JSON.stringify(menu)
            localStorage.setItem('menu_' + that.accountNo, menu)
            localStorage.setItem('DEFAULT_PRICE_URL', defaultPriceUrls[0].path)
            localStorage.setItem('menuVersion_' + that.accountNo, version)
            //创建本地数据库
            let db = localforage.createInstance({ name: that.accountNo + 'DB' })
            that.$store.commit('WEB_DB', db)
            initData()
            if(this.keepPsd){
              let user={
                accountNo:this.accountNo,
                password:this.password
              }
              localforage.setItem('user',user)
            }else{
              localforage.removeItem('user')
            }
            that.$router.push({ path: defaultPriceUrls[0].path })
          }
        })
      },
      register () {
        window.location.href = 'https://dlfd.hwaqing.cn/user/register'
      },
      isBrowser () {
        let that = this
        let chrome = this.isChrome()

        if (chrome == true) {
          return
        } else {
          const ms = that.$message({
            showClose: true,
            message: '报价器部分功能在您的浏览器内无法使用,建议您使用chrome浏览器!',
            type: 'warning',
            duration: 0
          })
        }
      },
      isChrome () {
        let ua = navigator.userAgent.toLocaleLowerCase()
        if (ua.match(/chrome/) != null) {
          return true
        } else {
          return false
        }
      },
      goXmfDoc () {
        window.location.href = 'http://xmf.doc.hwaqing.cn/quoter/'
      },
      keepPsdChange(){
        localforage.setItem('keepPsd',this.keepPsd)
      },
    },
    destroyed () {
      let that = this
      that.$message.closeAll()
    }
  }
</script>

<style scoped>

</style>
